import React, { useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import J7EmporiumCover from "../images/projects/j7-emporium-cover.jpeg";
import { Helmet } from "react-helmet";

const J7Emporium = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Payment plan data extracted from image
  const paymentData = [
    {
      category: "Studio Apartment",
      size: 732,
      priceSqft: 20000,
      totalValue: 14640000,
      dp25: 3660000,
      quarterlyInstallment: 998182,
    },
    {
      category: "1 Bed Apartment",
      size: 1004,
      priceSqft: 20000,
      totalValue: 20080000,
      dp25: 5020000,
      quarterlyInstallment: 1369091,
    },
    {
      category: "2 Bed Apartment",
      size: 1979,
      priceSqft: 18500,
      totalValue: 36611500,
      dp25: 9152875,
      quarterlyInstallment: 2496239,
    },
    {
      category: "Duplex",
      size: 2578,
      priceSqft: 18500,
      totalValue: 47693000,
      dp25: 11923250,
      quarterlyInstallment: 3251795,
    },
  ];

  const handleBookNow = () => {
    window.open("https://wa.me/923487172565", "_blank");
  };

  // Section image URLs (professional property/architecture themed)
  const sectionImages = {
    hero: J7EmporiumCover,
    transition: J7EmporiumCover,
    promise:
      "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80",
    islamabad:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcaRxbn_8dcu6WtTQqtaAUbwkSH_Gha3h97rDTnhJW9G240NmVgQrjlz0K&s=10",
    modern:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80",
    leisure:
      "https://images.unsplash.com/photo-1530018607912-eff2daa1bac4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80",
    club: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80",
    location:
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80",
    living:
      "https://images.unsplash.com/photo-1618220179428-22790b461013?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80",
    corporate:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80",
    radisson:
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80",
  };

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Helmet>
        <title>J7 Emporium - Premium Apartments in  B-17 Islamabad</title>
        <meta
          name="description"
          content="J7 Emporium offers luxury apartments in  B-17 Islamabad. CDA approved, family residential project with studios, 1-3 bed apartments & duplex penthouses."
        />
        <meta
          name="keywords"
          content="J7 Emporium,  B-17, Islamabad apartments, luxury housing, CDA approved, duplex penthouses"
        />
        <link
          rel="canonical"
          href="https://j7emporium.com/projects/j7-emporium"
        />
        <meta
          property="og:title"
          content="J7 Emporium - Premium Apartments in  B-17 Islamabad"
        />
        <meta
          property="og:description"
          content="Luxury living in Islamabad's prime location. CDA approved, family residential project with world-class amenities."
        />
        <meta property="og:image" content={J7EmporiumCover} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="J7 Emporium - Premium Apartments in  B-17"
        />
        <meta
          name="twitter:description"
          content="Experience luxury living at J7 Emporium,  B-17 Islamabad. CDA approved with state-of-the-art amenities."
        />
      </Helmet>
      {/* Hero Section */}
      <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
          style={{
            backgroundImage: `url(${sectionImages.hero})`,
            filter: "brightness(0.35) saturate(1.1)",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-emerald-900/60 to-emerald-950/80 z-1"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex flex-col items-center space-y-8">
            <div className="bg-emerald-800/30 backdrop-blur-sm px-8 py-3 rounded-full border border-emerald-400/30">
              <span className="text-emerald-200 font-medium tracking-widest text-sm">
                PREMIUM LIFESTYLE ADDRESS
              </span>
            </div>
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-extrabold text-white tracking-tight drop-shadow-lg">
              <span className="block">J7 EMPORIUM</span>
              <span className="text-2xl sm:text-3xl font-light text-emerald-300/90 block mt-2">
                B-17 · Islamabad
              </span>
            </h1>

            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 mt-4">
              <button
                onClick={handleBookNow}
                className="px-8 py-4 bg-emerald-500 hover:bg-emerald-400 text-white font-bold text-lg rounded-xl shadow-xl transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-3"
              >
                <i className="fab fa-whatsapp text-2xl"></i> Book Now
              </button>
              <button
                onClick={() => setIsModalOpen(true)}
                className="px-8 py-4 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-semibold text-lg rounded-xl border-2 border-white/50 shadow-xl transition-all duration-200 hover:scale-105 flex items-center justify-center gap-3"
              >
                <i className="fas fa-file-invoice-dollar text-emerald-300"></i>{" "}
                Payment Plan
              </button>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-6 text-white/90 max-w-3xl mx-auto bg-black/30 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
              <div className="text-center">
                <p className="text-sm uppercase tracking-wider text-emerald-200/80">
                  Booking Start
                </p>
                <p className="text-xl font-bold text-emerald-300">25% – 60%</p>
              </div>
              <div className="text-center">
                <p className="text-sm uppercase tracking-wider text-emerald-200/80">
                  Balance
                </p>
                <p className="text-xl font-bold text-white">
                  8 Quarterly Installments
                </p>
              </div>
              <div className="text-center">
                <p className="text-sm uppercase tracking-wider text-emerald-200/80">
                  Rates / Sq. Ft
                </p>
                <p className="text-xl font-bold text-white">From 18,500</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 1: New Transition */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src={sectionImages.transition}
            alt="J7 Emporium Transition"
            className="w-full h-full object-cover opacity-10"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-emerald-600 font-semibold tracking-widest text-sm uppercase">
                New Transition
              </span>
              <h2 className="text-4xl font-bold text-gray-900 mt-2">
                J7 EMPORIUM{" "}
                <span className="text-emerald-600">NEW TRANSITION</span>
              </h2>
              <p className="text-gray-600 mt-4 leading-relaxed text-lg">
                J7 Emporium has a new transition from 26 kanals to 46 kanals,
                which makes it an exceptionally enormous project of the capital
                city with unparalleled services and amenities for all
                Commercial, Residential and Hotels sectors.
              </p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={sectionImages.transition}
                alt="J7 Emporium"
                className="w-full h-80 object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Our Promise */}
      <section className="py-20 bg-gradient-to-br from-emerald-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-emerald-600 font-semibold tracking-widest text-sm uppercase">
              Built to Perfection
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mt-2">
              OUR PROMISE
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition">
              <img
                src={sectionImages.promise}
                alt="J7 Group"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="text-3xl mb-3">🏗️</div>
                <h3 className="text-xl font-bold text-gray-800">
                  Developer: J7 Group
                </h3>
                <p className="text-gray-600 mt-2 text-sm leading-relaxed">
                  J7 Group came into existence when the top Real Estate
                  entrepreneurs joined hands. The dynamic team is led by
                  visionaries with enriched brilliance, resources and
                  experience. J7 Group is known to have delivered real estate
                  projects in record time.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition">
              <img
                src="https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Architecture"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="text-3xl mb-3">🏛️</div>
                <h3 className="text-xl font-bold text-gray-800">
                  Architect: ARA & S+O
                </h3>
                <p className="text-gray-600 mt-2 text-sm leading-relaxed">
                  Ahmad Riaz & Associates (ARA) & S+O bring the best blend of
                  aesthetics and analytics. With immaculate attention to detail,
                  they have curated iconic elevations that promise structural
                  strength and functionality.
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition">
              <img
                src={sectionImages.radisson}
                alt="Radisson Hotel"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="text-3xl mb-3">🏨</div>
                <h3 className="text-xl font-bold text-gray-800">
                  Hotel: Radisson Hotel
                </h3>
                <p className="text-gray-600 mt-2 text-sm leading-relaxed">
                  A globally recognized hospitality brand known for exceptional
                  guest experiences. Radisson offers modern amenities, stylish
                  accommodations, and impeccable service for business and
                  leisure travelers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Islamabad */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src={sectionImages.islamabad}
            alt="Islamabad"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-emerald-900/70"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <div className="max-w-3xl">
            <span className="text-emerald-300 font-semibold tracking-widest text-sm uppercase">
              Capital City
            </span>
            <h2 className="text-4xl font-bold mt-2">ISLAMABAD</h2>
            <p className="text-2xl font-light text-emerald-200/90">
              The Beckoning Beauty
            </p>
            <p className="mt-4 leading-relaxed text-lg text-white/90">
              Islamabad the capital is known for its scenic beauty, gorgeous
              climate and geographical location. Islamabad is one of the most
              beautiful cities in South Asia. The beckoning, lush green views of
              the city are ideally planned for new businesses and residents
              alike.
            </p>
          </div>
        </div>
      </section>

      {/* Section 4: Modern Living */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <img
                src={sectionImages.modern}
                alt="Modern Living"
                className="rounded-2xl shadow-2xl w-full h-96 object-cover"
              />
            </div>
            <div className="order-1 md:order-2">
              <span className="text-emerald-600 font-semibold tracking-widest text-sm uppercase">
                Modern Living
              </span>
              <h2 className="text-4xl font-bold text-gray-900 mt-2">
                MODERN LIVING{" "}
                <span className="text-emerald-600">
                  MAXIMIZING POSSIBILITIES
                </span>
              </h2>
              <p className="text-gray-600 mt-4 leading-relaxed">
                J7 Emporium, a commercial and residential project in B-17, is a
                fusion of contemporary and modern architecture. The residential
                portion presents a unique and modern living experience in the
                heart of Islamabad. The commercial portion is ideal for
                investment with design and execution quality that speaks for
                itself.
              </p>
              <p className="text-gray-600 mt-4 leading-relaxed">
                J7 Emporium is designed to provide ultimate luxury and
                functionality under one roof. The location is ideal for
                businesses as it is in close proximity to the suburbs of
                Islamabad.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: Leisure & Entertainment */}
      <section className="py-20 bg-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-emerald-600 font-semibold tracking-widest text-sm uppercase">
              Leisure
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mt-2">
              UNLIMITED <span className="text-emerald-600">ENTERTAINMENT</span>
            </h2>
          </div>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition">
              <img
                src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Food Court"
                className="w-full h-48 object-cover"
              />
              <div className="p-5">
                <div className="text-3xl mb-2">🍽️</div>
                <h4 className="font-bold text-gray-800">Food Court</h4>
                <p className="text-sm text-gray-600">
                  Continental, traditional, fusion and international fast food
                  chains
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition">
              <img
                src="https://images.unsplash.com/photo-1511512578047-dfb367046420?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Fun City"
                className="w-full h-48 object-cover"
              />
              <div className="p-5">
                <div className="text-3xl mb-2">🎮</div>
                <h4 className="font-bold text-gray-800">Fun City</h4>
                <p className="text-sm text-gray-600">
                  Indoor theme play areas, gaming arcade and rides
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition">
              <img
                src="https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Cinema"
                className="w-full h-48 object-cover"
              />
              <div className="p-5">
                <div className="text-3xl mb-2">🎬</div>
                <h4 className="font-bold text-gray-800">Cinema</h4>
                <p className="text-sm text-gray-600">
                  The most luxurious Cineplex in the twin cities
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition">
              <img
                src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Gym & Pool"
                className="w-full h-48 object-cover"
              />
              <div className="p-5">
                <div className="text-3xl mb-2">🏋️</div>
                <h4 className="font-bold text-gray-800">Gym & Pool</h4>
                <p className="text-sm text-gray-600">
                  State-of-the-art gymnasium and indoor/outdoor swimming pool
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 6: J7 Club */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src={sectionImages.club}
            alt="J7 Club"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/80 to-emerald-950/90"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <div className="max-w-4xl">
            <span className="text-emerald-300 font-semibold tracking-widest text-sm uppercase">
              Luxury & Leisure
            </span>
            <h2 className="text-4xl font-bold mt-2">J7 CLUB</h2>
            <p className="text-2xl font-light text-emerald-200/90">
              Unmatched Entertainment
            </p>
            <p className="mt-4 leading-relaxed text-lg text-white/90">
              Experience luxury and leisure at its finest at J7 Club, a
              state-of-the-art destination designed for ultimate indulgence.
              Immerse yourself in cinematic bliss at our cutting-edge cinema
              hall, host unforgettable events in our lavish banquet hall, and
              savor a culinary journey at our diverse food court. Dive into
              excitement with Fun City, rejuvenate at our sparkling swimming
              pool, and sculpt your body at the Fitness Centre.
            </p>
          </div>
        </div>
      </section>

      {/* Section 7: Location & Boutique Hotel */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-emerald-50 rounded-2xl shadow-lg overflow-hidden">
              <img
                src={sectionImages.location}
                alt="Location"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <div className="text-3xl mb-3">📍</div>
                <h4 className="text-xl font-bold text-gray-800">
                  Prime Location
                </h4>
                <p className="text-gray-600 mt-2 leading-relaxed">
                  J7 Emporium is poised to be among Islamabad's most
                  sought-after leisure destinations due to its location facing a
                  lake and adjacent to a park with play areas and walking
                  tracks. The lush surroundings are a great background for
                  family outings.
                </p>
              </div>
            </div>
            <div className="bg-emerald-50 rounded-2xl shadow-lg overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Boutique Hotel"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <div className="text-3xl mb-3">🏩</div>
                <h4 className="text-xl font-bold text-gray-800">
                  Boutique Hotel & Banquet
                </h4>
                <p className="text-gray-600 mt-2 leading-relaxed">
                  Loft Boutique hotel & banquet hall with a lobby, signature
                  suites, smart family rooms, and the most sought-after venue
                  for all corporate, wedding, and social functions. The perfect,
                  versatile, and fabulous venue for public and private events.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 8: Extravagant Living */}
      <section className="py-20 bg-gradient-to-br from-emerald-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-emerald-600 font-semibold tracking-widest text-sm uppercase">
              Luxury Living
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mt-2">
              EXTRAVAGANT LIVING{" "}
              <span className="text-emerald-600">INGENIOUS COMFORTS</span>
            </h2>
          </div>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition">
              <img
                src="https://images.unsplash.com/photo-1618220179428-22790b461013?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Interiors"
                className="w-full h-48 object-cover"
              />
              <div className="p-5">
                <div className="text-3xl mb-2">🛋️</div>
                <h4 className="font-bold text-gray-800">
                  Aristocratic Interiors
                </h4>
                <p className="text-sm text-gray-600">
                  Personal sanctuary with luxurious finishing and lavish design
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition">
              <img
                src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Views"
                className="w-full h-48 object-cover"
              />
              <div className="p-5">
                <div className="text-3xl mb-2">🌅</div>
                <h4 className="font-bold text-gray-800">Panoramic Views</h4>
                <p className="text-sm text-gray-600">
                  Spectacular views of the city, wake up to breathtaking sights
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition">
              <img
                src="https://images.unsplash.com/photo-1556911220-bff31c812dba?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Kitchen"
                className="w-full h-48 object-cover"
              />
              <div className="p-5">
                <div className="text-3xl mb-2">🍳</div>
                <h4 className="font-bold text-gray-800">
                  The Ultimate Kitchen
                </h4>
                <p className="text-sm text-gray-600">
                  Contemporary kitchens with bespoke fittings and superior work
                  spaces
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition">
              <img
                src="https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Spa"
                className="w-full h-48 object-cover"
              />
              <div className="p-5">
                <div className="text-3xl mb-2">🛁</div>
                <h4 className="font-bold text-gray-800">At Home Spa</h4>
                <p className="text-sm text-gray-600">
                  Sumptuous bathrooms with stylish basins, baths, and high-end
                  porcelain
                </p>
              </div>
            </div>
          </div>
          <div className="mt-8 bg-white rounded-2xl shadow-lg p-6 text-center">
            <p className="text-gray-700 leading-relaxed">
              <span className="font-bold text-emerald-600">J7 Homes:</span>{" "}
              Penthouses, condos, and Multi Deck Apartments (studio, 1, 2, 3
              Beds) in the west wing. Most apartments have private balconies or
              terraces with views of B-17's landscape or private courtyards.
            </p>
          </div>
        </div>
      </section>

      {/* Section 9: Corporate & Radisson */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-2xl shadow-lg overflow-hidden">
              <img
                src={sectionImages.corporate}
                alt="Corporate"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <div className="text-3xl mb-3">🏢</div>
                <h4 className="text-xl font-bold text-gray-800">
                  Corporate Spirit
                </h4>
                <p className="text-gray-700 mt-2 leading-relaxed">
                  J7 Corporate Tech tower with single & multi-level smart and
                  convertible offices offering the perfect address for
                  headquarters and regional offices for financial, technology,
                  healthcare & defense sectors.
                </p>
              </div>
            </div>
            <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-2xl shadow-lg overflow-hidden">
              <img
                src={sectionImages.radisson}
                alt="Radisson Hotel"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <div className="text-3xl mb-3">🏨</div>
                <h4 className="text-xl font-bold text-gray-800">
                  Radisson Hotel
                </h4>
                <p className="text-gray-700 mt-2 leading-relaxed">
                  A testimony of Radisson's presence in the Hotel segment of
                  Emporium with a balanced combination of efficient design &
                  pragmatic operations tailored for a wonderful & relevant stay
                  for guests.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 10: Floor Plans */}
      <section className="py-20 bg-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-emerald-600 font-semibold tracking-widest text-sm uppercase">
              Residences
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mt-2">
              FLOOR PLANS
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition text-center">
              <img
                src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="One Bed"
                className="w-full h-56 object-cover"
              />
              <div className="p-6">
                <div className="text-5xl mb-3">🛏️</div>
                <h4 className="text-2xl font-bold text-gray-800">One Bed</h4>
                <p className="text-gray-600">Comfortable living space</p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition text-center">
              <img
                src="https://images.unsplash.com/photo-1560448204-603b3fc33ddc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Two Bed"
                className="w-full h-56 object-cover"
              />
              <div className="p-6">
                <div className="text-5xl mb-3">🛏️🛏️</div>
                <h4 className="text-2xl font-bold text-gray-800">Two Bed</h4>
                <p className="text-gray-600">Spacious family apartment</p>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition text-center">
              <img
                src="https://images.unsplash.com/photo-1560185007-cde436f6a4d0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1770&q=80"
                alt="Three Bed"
                className="w-full h-56 object-cover"
              />
              <div className="p-6">
                <div className="text-5xl mb-3">🛏️🛏️🛏️</div>
                <h4 className="text-2xl font-bold text-gray-800">Three Bed</h4>
                <p className="text-gray-600">Luxurious living space</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enhanced Payment Plan Modal - Only Payment Details */}
      <Transition appear show={isModalOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => setIsModalOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/80 backdrop-blur-md" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95 translate-y-4"
                enterTo="opacity-100 scale-100 translate-y-0"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100 translate-y-0"
                leaveTo="opacity-0 scale-95 translate-y-4"
              >
                <Dialog.Panel className="w-full max-w-5xl transform overflow-hidden rounded-3xl bg-white shadow-2xl transition-all">
                  {/* Modal Header with Emporium Green Theme */}
                  <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 p-6">
                    <div className="flex justify-between items-start">
                      <div>
                        <Dialog.Title className="text-2xl font-extrabold text-white tracking-tight">
                          J7 EMPORIUM
                          <span className="block text-base font-medium text-emerald-200 mt-1">
                            Payment Plan Details
                          </span>
                        </Dialog.Title>
                      </div>
                      <button
                        onClick={() => setIsModalOpen(false)}
                        className="text-white/80 hover:text-white text-3xl transition-all hover:rotate-90 duration-300"
                      >
                        ×
                      </button>
                    </div>
                  </div>

                  {/* Payment Content */}
                  <div className="p-6 space-y-6">
                    {/* Rate Cards */}
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm bg-emerald-50 p-4 rounded-xl border border-emerald-200">
                      <div className="font-semibold text-gray-700">
                        Ground Floor L1
                      </div>
                      <div className="font-semibold text-emerald-600">
                        58,000
                      </div>
                      <div className="font-semibold text-gray-700">
                        Residential Tower
                      </div>
                      <div>Ground Floor L2</div>
                      <div className="text-emerald-600">58,000</div>
                      <div>Studio / 1 Bed</div>
                      <div>Food Court / Mezzanine</div>
                      <div className="text-emerald-600">70,000</div>
                      <div>2 Bed / 3 Bed</div>
                      <div>Technology Zone (1st–4th)</div>
                      <div className="text-emerald-600">60,000</div>
                      <div>Service Apartment</div>
                      <div className="col-span-2 text-right font-medium text-emerald-700">
                        Corporate Offices
                      </div>
                      <div className="font-medium text-emerald-700">40,000</div>
                    </div>

                    {/* Payment Table */}
                    <div className="overflow-x-auto rounded-xl border border-gray-200">
                      <table className="min-w-full divide-y divide-gray-200 text-sm">
                        <thead className="bg-emerald-600 text-white">
                          <tr>
                            <th className="px-4 py-3 text-left font-semibold">
                              Category
                            </th>
                            <th className="px-4 py-3 text-left font-semibold">
                              Size (sq.ft)
                            </th>
                            <th className="px-4 py-3 text-left font-semibold">
                              Price/Sqft
                            </th>
                            <th className="px-4 py-3 text-left font-semibold">
                              Total Value
                            </th>
                            <th className="px-4 py-3 text-left font-semibold">
                              25% DP
                            </th>
                            <th className="px-4 py-3 text-left font-semibold">
                              Quarterly Installments
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100 bg-white">
                          {paymentData.map((item, idx) => (
                            <tr
                              key={idx}
                              className="hover:bg-emerald-50 transition"
                            >
                              <td className="px-4 py-3 font-medium text-gray-800">
                                {item.category}
                              </td>
                              <td className="px-4 py-3 text-gray-700">
                                {item.size.toLocaleString()}
                              </td>
                              <td className="px-4 py-3 text-gray-700">
                                {item.priceSqft.toLocaleString()}
                              </td>
                              <td className="px-4 py-3 text-gray-800 font-semibold">
                                {item.totalValue.toLocaleString()}
                              </td>
                              <td className="px-4 py-3 text-emerald-600 font-bold">
                                {item.dp25.toLocaleString()}
                              </td>
                              <td className="px-4 py-3 text-emerald-600 font-bold">
                                {item.quarterlyInstallment.toLocaleString()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Notes */}
                    <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-xl">
                      <p className="font-bold text-gray-800 flex items-center gap-2">
                        <span>📌</span> IMPORTANT NOTES
                      </p>
                      <ul className="list-disc list-inside space-y-1 mt-2 text-gray-700">
                        <li>
                          Corner units will be charged{" "}
                          <span className="font-bold text-red-600">
                            10% extra
                          </span>
                        </li>
                        <li>
                          Margalla facing units will be charged{" "}
                          <span className="font-bold text-red-600">
                            5% extra
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Modal Footer */}
                  <div className="border-t border-gray-200 p-4 bg-gray-50 rounded-b-3xl flex justify-between items-center">
                    <span className="text-sm text-gray-500">
                      J7 Emporium · B-17 Islamabad
                    </span>
                    <button
                      onClick={() => setIsModalOpen(false)}
                      className="px-6 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-semibold transition-all shadow-md hover:shadow-lg"
                    >
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center">
          <div>
            <span className="text-xl font-bold text-emerald-400">
              J7 EMPORIUM
            </span>
            <p className="text-sm text-gray-400 mt-1">
              B-17 Islamabad · Premium Lifestyle
            </p>
          </div>
          <div className="flex items-center gap-4 mt-4 sm:mt-0">
            <a
              href="tel:+923487172565"
              className="text-gray-300 hover:text-emerald-400 transition"
            >
              <i className="fas fa-phone-alt mr-2"></i> +92 348 7172565
            </a>
            <a
              href="https://wa.me/923487172565"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-emerald-600 hover:bg-emerald-700 px-4 py-2 rounded-lg text-sm font-medium transition"
            >
              <i className="fab fa-whatsapp mr-2"></i> WhatsApp
            </a>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 mt-4 pt-4 border-t border-gray-800 text-center text-xs text-gray-500">
          J7 Group · Built to Perfection
        </div>
      </footer>
    </div>
  );
};

export default J7Emporium;
